import React from "react";
import {
  Typography,
  Divider,
  Card,
  CardContent,
  Button,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

import DocItem from "./DocItem";
import useFileLoad from "../../../../../hooks/useFileLoad";
import { useAuth } from "../../../../../contexts/AuthContext";

const docList = [
  { name: "IELTS"},
  { name: "SAT"},
  { name: "School Report" },
  { name: "Personal Statement"},
  { name: "Accomplishment Certificates"},
];

const useStyles = makeStyles((theme) => ({
  wrapper: {
    // height: "82vh",
    // overflowY: "scroll",
    // "&::-webkit-scrollbar": {
    //   display: "none",
    // },
    padding: theme.spacing(2),
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  card: {
    width: "100%",
  },
  zipButton: {
    display: "flex",
    justifyContent: "center",
  },
}));

export default function DocumentsTab() {
  const classes = useStyles();
  const {currentUser} = useAuth();
  const {docs,error} = useFileLoad(currentUser.uid);
  
  return (
    <div className={classes.wrapper}>
      <Typography variant="h4" color="textPrimary" gutterBottom>
        List of Documents
      </Typography>
      <Divider className={classes.divider} />
      {error && <Alert severity="error">{error}</Alert>}
      <Card className={classes.card} variant="outlined">
        <CardContent>
          {docList.map((docItem, index) => (
            <DocItem key={index} data={docItem} dbData={docs} />
          ))}
          <div className={classes.zipButton}>
            <Button variant="outlined" color="primary">
              Zip and Download All Documents
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
